import { useEffect } from 'react';

const useRedirectIfNotInIframe = (targetUrl) => {
    useEffect(() => {

        // Skip redirect if in development environment
        if (process.env.REACT_APP_ENV === 'development') {
            return;
        }

        // Verifica si estamos en un iframe.
        /*if (window.parent === window) {
            window.location.href = targetUrl;
        }*/
    }, [targetUrl]);
};

export default useRedirectIfNotInIframe;